import React, { FC, useMemo, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { FInter, FlexBox } from '@brg/ui';
import { Project, Competition, CompetitionAPI, API } from '@brg/api';

import { ComputedProject } from '../../../helpers/types/computed/ComputedProject';
import { AppTester } from '../../../../supporting';
import { bArray } from 'core/utils';

interface Nominations {
    voteCriterias?: any;
    nominations?: any;
}
export const PSTeam: FC<{ project: ComputedProject; raw: Project }> = ({ project, raw }) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const isHSEDesign = AppTester.isHSEDesign();
    const [competition, setCompetition] = useState<Competition>();

    //@ts-ignore
    const competitionId = useMemo<string>(() => raw?.competitionApproves?.[0]?.competitionId, [raw]);
    const canVote = useMemo(() => !!competitionId, [competitionId]);
    const nomination = useMemo(() => {
        if (
            competition &&
            competition.nominations &&
            bArray.isArray(competition.nominations) &&
            competition.nominations.length > 0
        ) {
            return competition.nominations[0];
        }
        return null;
    }, [competition]);

    useEffect(() => {
        if (competitionId) {
            CompetitionAPI.Get({ idCompetition: competitionId })
                .then((v) => v.json())
                .then((v) => API.toLang<Competition>(v, i18n.language))
                .then(setCompetition);
        }
    }, [competitionId, i18n.language]);

    useEffect(() => {
        if (nomination) {
            CompetitionAPI.Get({ idCompetition: competitionId })
              .then((v) => v.json())
              .then((v) => API.toLang<Nominations>(v, i18n.language));
        }
    }, [nomination, i18n.language, competitionId]);

    return (
        <>
            {!canVote ? (
                <FlexBox direction={'column'}>
                    <FlexBox>
                        {project.team.has && (
                            <FInter.TextFlex color={theme.tags.textColor}>
                                {t('team')}&nbsp;
                                <a
                                    href={
                                        isHSEDesign
                                            ? '/context/hse'
                                            : process.env.REACT_APP_URL_DAFES +
                                              'context/hse'
                                    }
                                    className={'a-green'}
                                >
                                    {project.team.name}
                                </a>
                            </FInter.TextFlex>
                        )}
                    </FlexBox>
                </FlexBox>
            ) : null}
        </>
    );
};
import React, { FC, useMemo, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { FInter, FlexBox } from '@brg/ui';
import { Project, Competition, CompetitionAPI, API } from '@brg/api';

import { ComputedProject } from '../../../helpers/types/computed/ComputedProject';
import { AppTester } from '../../../../supporting';
import { bArray } from 'core/utils';

interface Nominations {
    voteCriterias?: any;
    nominations?: any;
}
export const PSTeam: FC<{ project: ComputedProject; raw: Project }> = ({ project, raw }) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const isHSEDesign = AppTester.isHSEDesign();
    const [competition, setCompetition] = useState<Competition>();

    //@ts-ignore
    const competitionId = useMemo<string>(() => raw?.competitionApproves?.[0]?.competitionId, [raw]);
    const canVote = useMemo(() => !!competitionId, [competitionId]);
    const nomination = useMemo(() => {
        if (
            competition &&
            competition.nominations &&
            bArray.isArray(competition.nominations) &&
            competition.nominations.length > 0
        ) {
            return competition.nominations[0];
        }
        return null;
    }, [competition]);

    useEffect(() => {
        if (competitionId) {
            CompetitionAPI.Get({ idCompetition: competitionId })
                .then((v) => v.json())
                .then((v) => API.toLang<Competition>(v, i18n.language))
                .then(setCompetition);
        }
    }, [competitionId, i18n.language]);

    useEffect(() => {
        if (nomination) {
            CompetitionAPI.Get({ idCompetition: competitionId })
              .then((v) => v.json())
              .then((v) => API.toLang<Nominations>(v, i18n.language));
        }
    }, [nomination, i18n.language, competitionId]);

    return (
        <>
            {!canVote ? (
                <FlexBox direction={'column'}>
                    <FlexBox>
                        {project.team.has && (
                            <FInter.TextFlex color={theme.tags.textColor}>
                                {t('team')}&nbsp;
                                <a
                                    href={
                                        isHSEDesign
                                            ? '/context/hse'
                                            : process.env.REACT_APP_URL_DAFES +
                                              'context/hse'
                                    }
                                    className={'a-green'}
                                >
                                    {project.team.name}
                                </a>
                            </FInter.TextFlex>
                        )}
                    </FlexBox>
                </FlexBox>
            ) : null}
        </>
    );
};
